import { observer } from 'mobx-react';
import { useState } from 'react';

import { useFormikContext } from 'formik';

import { makeStyles } from '@bequestinc/wui';
import { Grid } from '@mui/material';

import { useGlobalContext } from 'hooks';

import ChipSelector from 'components/ChipSelector';

const useStyles = makeStyles()({
  textFieldPadded: {
    width: '100%',
  },
});

interface PropTypes {
  name: string;
  value?: string[];
  restrictedServices?: number[];
  // Remaining props are forwarded to ChipSelector.
  [key: string]: unknown;
}

const AttorneyServicesSelector = ({
  name,
  value,
  restrictedServices = [],
  ...props
}: PropTypes) => {
  const { setFieldValue } = useFormikContext();
  const { classes } = useStyles();
  const { services } = useGlobalContext();
  const onlyAttorneyProvidedServices = services.services
    .filter(service => service.isAttorneyProvided)
    .map(service => service.name);
  const [servicesByCategory, setServicesByCategory] = useState<Record<string, string[]>>(
    services.categorizeServices(value) as Record<string, string[]>,
  );

  const onChange = (category: string) => (_: unknown, serviceList: string[]) => {
    // Note that `serviceList` is an array here
    const newServices = { ...servicesByCategory };
    newServices[category] = serviceList;
    const newFlatServices = Object.values(newServices).flat();
    setServicesByCategory(newServices);
    setFieldValue(name, newFlatServices);
  };

  if (services.loading) {
    return null;
  }

  return (
    <Grid container spacing={2}>
      {services.categories.map(category => {
        return (
          <Grid item className={classes.textFieldPadded} key={category}>
            <ChipSelector
              {...props}
              name={name}
              options={services.servicesByCategory[category].filter(
                service =>
                  !restrictedServices.includes(services.getServiceId(service)) &&
                  onlyAttorneyProvidedServices.includes(service),
              )}
              value={value.filter(val => services.servicesByCategory[category].includes(val))}
              onChange={onChange(category)}
              label={category}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default observer(AttorneyServicesSelector);
